import { CSSProperties, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fontSize?: number
  className?: string
}

const StrokeText = ({ fontSize = 16, children, className }: Props): React.ReactElement => {
  const style: CSSProperties = {
    color: 'white',
    fontSize,
    textShadow: '-1px -1px 0 #000,  1px -1px 0 #000,-1px 1px 0 #000, 1px 1px 0 #000',
  }

  return (
    <p className={className} style={style}>
      {children}
    </p>
  )
}

export default StrokeText
